<section>
  <div markdown ngPreserveWhitespaces appDynamicMarkdownLink>
    {{ block.body }}
  </div>

  <div id="hubspotFormWrapper"></div>
</section>
